module.exports = __webpack_public_path__ + "img/coo_setting.958eb3f5.png";